import React, { useEffect } from "react";
import { AddressInfo } from "../WeddingInfo/WeddingInfo";

interface WeddingMapProps {
  backgroundColor: string;
  textColor: string;
  addressInfo: AddressInfo;
}

const WeddingMap: React.FC<WeddingMapProps> = ({
  backgroundColor,
  textColor,
  addressInfo,
}) => {
  const clientId = "ppr0w7ahcd";

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${clientId}`;
    script.async = true;
    script.onload = () => {
      const map = new window.naver.maps.Map("map", {
        center: new window.naver.maps.LatLng(addressInfo.lat, addressInfo.lon),
        zoom: 16, // 기본 zoom 값
      });

      // 기본 마커 추가 (커스텀 이미지 제거)
      new window.naver.maps.Marker({
        position: new window.naver.maps.LatLng(
          addressInfo.lat,
          addressInfo.lon
        ),
        map,
      });
    };

    document.body.appendChild(script);
  }, []);

  // 네이버 지도에서 내 위치로 오시는 길 열기
  const handleNavigateToNaverMap = () => {
    const webUrl = addressInfo.naverAddress;
    window.open(webUrl, "_blank");
  };

  return (
    <div className="w-full max-w-md mt-4 flex justify-center flex-col items-center">
      {/* 지도 */}
      <div id="map" className="w-[300px] h-[300px] rounded-lg shadow-md"></div>

      {/* 네이버 길찾기 버튼 */}
      <button
        onClick={handleNavigateToNaverMap}
        className={`mt-6 ${textColor} ${backgroundColor} font-bold py-2 px-6 rounded-lg transition`}
      >
        📍 네이버로 길 찾기
      </button>
    </div>
  );
};

export default WeddingMap;
